export const withoutKey = <T>(record: Record<string, T>, key: string): Record<string, T> => {
    const next = { ...record };
    delete next[key];
    return next;
};
